import { Box, Typography } from "@mui/material";
import React from "react";
import ReactApexChart from "react-apexcharts";
const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const CustomGraph = ({
  colors,
  labels,
  series,
  graphTitle,
  pieHeight,
  pieWidth,
  legendPosition,
}) => {
  const capitalizedLabels = labels.map((label) => capitalizeFirstLetter(label));
  const options = {
    chart: {
      type: "donut",
      width: "100%",
      offsetX: 0,
      
      offsetY: 0,
      parentHeightOffset: 0,
      height: "100%",
      redrawOnParentResize: false,
      
    },
    dataLabels: {
      enabled: false,
    },

    labels: capitalizedLabels,
    noData: {
      text: "No Data Found",
      align: "center",
      verticalAlign: "center",
      offsetX: 0,
      offsetY: 0,
      style: {
        color: "black",
        fontSize: "15px",
      },
    },

    series: series ? series : [],
    colors: colors,

    responsive: [
      {
        breakpoint: 600,
        options: {
          chart: {
            height: "100%",
          },
          legend: {
            position: "right",
          },
        },
      },
    ],
    legend: {
      show: true,

      fontSize: "14px",
      position: legendPosition,
      
      width: "100%",
      height: "100%",
      horizontalAlign: "center",
      verticalAlign: "center",
      onItemClick: {
        toggleDataSeries: true,
      },
      onItemHover: {
        highlightDataSeries: true,
      },
    },
    yaxis:{
      show: true,
      maxWidth: 160,
      minWidth: 100,
      labels:{
        show: true,

        align: "right"
      }

    }
  };

  return (
    <>
      <Typography
        sx={{
          color: "#000000",
          fontSize: "20px",
          fontWeight: "700",
          borderBottom: "1px solid #463812",
        }}
      >
        {graphTitle}
      </Typography>
      <Box sx={{ marginTop: "1rem" }}>
        <ReactApexChart
          options={options}
          series={options.series}
          width={pieWidth}
          height={pieHeight}
          type="donut"
        />
      </Box>
    </>
  );
};

export default CustomGraph;
